export enum StatisticsDaily {
  ProductUpload = 'productupload',
  SampleUpload = 'sampleupload',
  NewCustomer = 'newcustomer',
  NewOrder = 'neworder',
  OrderAmount = 'orderamount'
}
